import { awsCognitoAuthApiRef } from './apis';

/**
 * Sign-in providers offered by the committed app: ONLY AWS Cognito SSO.
 *
 * Guest sign-in (for local dev / headless E2E) is a local-only edit that is never committed — see
 * CLAUDE.md "Local-dev gotchas". It must never be added here: a committed 'guest' provider would ship
 * guest auth to beta/prod. The signInProviders.test.ts guard asserts guest is absent.
 */
export function signInProviders() {
  return [
    {
      id: 'oauth2',
      title: 'AWS Cognito SSO',
      message: 'Sign in using AWS Cognito + SSO',
      apiRef: awsCognitoAuthApiRef,
    },
  ];
}
